'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _DropdownButton = require('react-bootstrap/lib/DropdownButton');

var _DropdownButton2 = _interopRequireDefault(_DropdownButton);

var _MenuItem = require('react-bootstrap/lib/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var DownloadLienStatementDropdown = (_dec = (0, _mobxReact.inject)('FunderStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(DownloadLienStatementDropdown, _Component);

  function DownloadLienStatementDropdown() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DownloadLienStatementDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DownloadLienStatementDropdown.__proto__ || Object.getPrototypeOf(DownloadLienStatementDropdown)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'isDownloading', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DownloadLienStatementDropdown, [{
    key: 'generateLienStatement',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(by) {
        var _props, FunderStore, lawfirm;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, FunderStore = _props.FunderStore, lawfirm = _props.lawfirm;


                this.isDownloading = true;

                _context.prev = 2;
                _context.next = 5;
                return FunderStore.downloadTemplates(by, lawfirm);

              case 5:
                _context.prev = 5;

                this.isDownloading = false;
                return _context.finish(5);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2,, 5, 8]]);
      }));

      function generateLienStatement(_x) {
        return _ref2.apply(this, arguments);
      }

      return generateLienStatement;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          showByAttorney = _props2.showByAttorney,
          showByLawfirm = _props2.showByLawfirm,
          FunderStore = _props2.FunderStore,
          shouldShowByLawfirm = !!showByLawfirm && !!FunderStore.templateLawFirm,
          shouldShowByAttorney = !!showByAttorney && !!FunderStore.templateAttorney;


      return _react2.default.createElement(
        _DropdownButton2.default,
        {
          className: 'border-green',
          title: this.isDownloading ? 'Downloading...' : 'Download Lien Statement',
          disabled: this.isDownloading,
          id: 'dropdown-lien-statements',
          pullRight: true
        },
        shouldShowByLawfirm && _react2.default.createElement(
          _MenuItem2.default,
          {
            onSelect: this.generateLienStatement,
            eventKey: 'lawfirm' },
          'By Law Firm'
        ),
        shouldShowByAttorney && _react2.default.createElement(
          _MenuItem2.default,
          {
            onSelect: this.generateLienStatement,
            eventKey: 'attorney' },
          'By Attorney'
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return DownloadLienStatementDropdown;
}(_react.Component), _class3.defaultProps = {
  showByAttorney: true,
  showByLawfirm: true
}, _class3.propTypes = {
  FunderStore: _propTypes2.default.object.isRequired,
  lawfirm: _propTypes2.default.object.isRequired,
  showByAttorney: _propTypes2.default.bool,
  showByLawfirm: _propTypes2.default.bool
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isDownloading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class2)) || _class) || _class) || _class);
var _default = DownloadLienStatementDropdown;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DownloadLienStatementDropdown, 'DownloadLienStatementDropdown', '/app/src/components/page-case-search-results/DownloadLienStatementDropdown.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case-search-results/DownloadLienStatementDropdown.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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